import { createReducer, on } from '@ngrx/store';
import { Role } from 'app/modules/administration/access-control/roles/roles.model';
import * as RoleActions from './roles.actions';

export interface RoleState {
  roles: Role[];
  selectedRole: Role | null;
  loading: boolean;
  error: any;
}

export const initialState: RoleState = {
  roles: [],
  selectedRole: null,
  loading: false,
  error: null,
};

export const rolesReducer = createReducer(
  initialState,

  // ----------- Load All Roles -----------
  on(RoleActions.loadRoles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RoleActions.loadRolesSuccess, (state, { roles }) => ({
    ...state,
    roles,
    loading: false,
  })),

  on(RoleActions.loadRolesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ----------- Create Role -----------
  on(RoleActions.createRole, (state) => ({
    ...state,
    loading: true,
  })),

  on(RoleActions.createRoleSuccess, (state, { role }) => ({
    ...state,
    roles: [...state.roles, role],
    loading: false,
  })),

  on(RoleActions.createRoleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // ----------- Update Role -----------
  on(RoleActions.updateRoleSuccess, (state, { role }) => ({
    ...state,
    roles: state.roles.map((r) => (r.id === role.id ? role : r)),
  })),

  on(RoleActions.updateRoleFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // ----------- Soft Delete Role -----------
  on(RoleActions.softDeleteRoleSuccess, (state, { id }) => ({
    ...state,
    roles: state.roles.filter((r) => r.id !== id),
  })),

  on(RoleActions.softDeleteRoleFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // ----------- Select Role -----------
  on(RoleActions.selectRole, (state, { role }) => ({
    ...state,
    selectedRole: role,
  }))
);
